import { injectIntl } from 'react-intl';

import TransactionMetaPage from './TransactionMeta.page';

export default injectIntl(TransactionMetaPage);
